module.exports = __webpack_public_path__ + "Flag-608.017751ba50544f76759a9291b660f673.svg";